import {
  iProspectFile,
  eCrmProspectStatus,
  eCrmPriority,
} from 'services/Crm/Crm.type';

export type Temperature = 'hot' | 'warm' | 'cold';

const STATUS_SCORE: Record<eCrmProspectStatus, number> = {
  new: 10,
  contacted: 25,
  qualified: 40,
  proposal: 60,
  negotiation: 80,
  won: 100,
  lost: 5,
};

const PRIORITY_BONUS: Record<eCrmPriority, number> = {
  low: 0,
  medium: 5,
  high: 10,
};

export function computeScore(
  prospect: iProspectFile,
  interactionsCount?: number
): number {
  const base = STATUS_SCORE[prospect.status] ?? 10;
  const priority = PRIORITY_BONUS[prospect.priority] ?? 0;
  const interactions = Math.min((interactionsCount ?? 0) * 2, 10);
  return Math.min(base + priority + interactions, 100);
}

export function computeTemperature(prospect: iProspectFile): Temperature {
  if (prospect.status === 'won') return 'hot';
  if (prospect.status === 'lost') return 'cold';
  if (
    ['proposal', 'negotiation'].includes(prospect.status) &&
    prospect.priority === 'high'
  ) {
    return 'hot';
  }
  if (['qualified', 'proposal', 'negotiation'].includes(prospect.status)) {
    return 'warm';
  }
  if (prospect.status === 'contacted' && prospect.priority === 'high') {
    return 'warm';
  }
  return 'cold';
}

export const TEMPERATURE_EMOJI: Record<Temperature, string> = {
  hot: '\uD83D\uDD25',
  warm: '\u2600\uFE0F',
  cold: '\u2744\uFE0F',
};
